import { render, staticRenderFns } from "./ActiveContacts.vue?vue&type=template&id=7d51d408&scoped=true&lang=pug"
import script from "./ActiveContacts.vue?vue&type=script&lang=js"
export * from "./ActiveContacts.vue?vue&type=script&lang=js"
import style0 from "./ActiveContacts.vue?vue&type=style&index=0&id=7d51d408&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d51d408",
  null
  
)

export default component.exports